import { cookiePreferences } from "./cookie-consents";

export function init () {    
    const videoPlayTriggers = document.querySelectorAll('.js-video-play');
    
    // Loop over all play triggers to setup associated video embeds etc
    videoPlayTriggers.forEach((trigger, i) => {
        let container = trigger.closest('.js-feature-video'),
            video = container.querySelector('iframe'),
            posterFrame = container.querySelector('.js-poster-frame'),
            options = {
                events: {
                    'onReady': () => {
                        trigger.classList.add('video-ready');
                    }
                }
            },
            player;

        // If either analytics or advertising consent NOT given, swap out video for one loaded over no-cookie domain
        if (!cookiePreferences.analytics || !cookiePreferences.analytics) {
            // Rebuild player using no-cookie src domain
            // Get the video ID from the existing src
            const srcComponents = video.src.split('/');
            const videoId = srcComponents[srcComponents.length - 1];
            
            let newVideo = document.createElement('div');

            newVideo.id = 'video-cover-' . i;

            // Replace original video with new video placeholder div
            video.replaceWith(newVideo);
            
            options.videoId = videoId;
            options.width = '1280';
            options.height = '720';
            options.host = 'https://www.youtube-nocookie.com';

            // Build YouTube player
            player = new YT.Player(newVideo, options); 
        } else {
            //  Add unique ID to the video element and ensure the src has the enable api query string parameter
            video.id = 'video-cover-' . i;

            if (video.src.indexOf('?') !== -1) {
                video.src = video.src + '&enablejsapi=1';
            } else {
                video.src = video.src + '?enablejsapi=1';
            }
            
            // Build YouTube player
            player = new YT.Player(video, options); 
        }

        // Attach click event to this play trigger
        trigger.addEventListener('click', () => {
            // Fade out play controls and poster image
            posterFrame.classList.add('hide');

            // Play video once poster frame has hidden
            setTimeout(() => {
                posterFrame.style.zIndex = 0;

                player.playVideo();
            }, 300);
        });
    });
}